












































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import draggable from "vuedraggable"
import { mapState } from "vuex"
import _ from "lodash"

@Component({
  components: {
    draggable,
  },
  computed: {
    ...mapState("BodyPart", {
      bodyParts: "bodyParts", // is used in BodyMapMixins
    }),
  },
})
export default class QuestionAnswerOptions extends Vue {
  @Prop({ type: Array }) answerOptions!: Record<string, string>[]
  @Prop({ default: false, type: Boolean }) isMulti!: boolean

  bodyParts!: Record<string, string>[]

  get syncedAnswerOptions() {
    return this.answerOptions
  }
  set syncedAnswerOptions(v) {
    this.$emit("update:answer-options", v)
  }

  selectedTemplate = null

  bulkOptions = ""

  templateOptions = [
    {
      display_name: "K10 number associated",
      key: "k10_number_associated",
    },
    {
      display_name: "No number associated",
      key: "no_number_associated",
    },
    {
      display_name: "Normal / Abnormal",
      key: "normal_or_abnormal",
    },
    {
      display_name: "Yes / No",
      key: "yes_or_no",
    },
    {
      display_name: "True / False",
      key: "true_or_false",
    },
    {
      display_name: "Restricted / Unrestricted",
      key: "restricted_or_unrestricted",
    },
    {
      display_name: "Timeframe (number associated)",
      key: "timeframe",
    },
  ]

  directions = [
    {
      text: 'Above',
      value: 'above',
    },
    {
      text: 'Below',
      value: 'below',
    }
  ]

  templates = {
    k10_number_associated: {
      1: "None of the time",
      2: "A little of the time",
      3: "Some of the time",
      4: "Most of the time",
      5: "All of the time",
    },
    no_number_associated: {
      none_of_the_time: "None of the time",
      a_little_of_the_time: "A little of the time",
      some_of_the_time: "Some of the time",
      most_of_the_time: "Most of the time",
      all_of_the_time: "All of the time",
    },
    normal_or_abnormal: {
      normal: "Normal",
      abnormal: "Abnormal",
    },
    yes_or_no: {
      yes: "Yes",
      no: "No",
    },
    true_or_false: {
      true: "True",
      false: "False",
    },
    restricted_or_unrestricted: {
      restricted: "Restricted",
      unrestricted: "Unrestricted",
    },
    timeframe: {
      0: "Not applicable",
      1: "Monthly or less",
      2: "2-4 times a month",
      3: "2-4 times a week",
      4: "4 or more per week",
    },
  }

  isSelectedAll = false

  allowToGenerateKey: number[] = []

  bodyPartsHint =
    "* If you want to change the order of the selected body parts, please select 'None' in the answer option template"

  beforeMount() {
    if (!this.bodyParts.length) {
      this.$store.dispatch("BodyPart/fetchList")
    }
  }

  handleAdd() {
    this.syncedAnswerOptions.push({
      display_name: "",
      key: "",
    })
  }

  handleBulkImport() {
    const optionStrings = this.bulkOptions.split("\n"),
      options: Record<string, string>[] = []
    for (const index in optionStrings) {
      const optionString = optionStrings[index]
      if (optionString) {
        const option = {
          display_name: "",
          key: "",
        }
        let stringArray = optionString.split("|")
        if (optionString.indexOf(" | ") > 0) {
          stringArray = optionString.split(" | ")
        }
        if (stringArray[1]) {
          option.key = this.toSnakeCase(stringArray[1])
          option.display_name = stringArray[0]
        } else {
          option.key = this.toSnakeCase(optionString)
          option.display_name = optionString
        }
        options.push(option)
      }
    }
    this.syncedAnswerOptions = options
  }

  handleDelete(index) {
    if (this.syncedAnswerOptions.length === 1) {
      this.syncedAnswerOptions = [
        {
          display_name: "",
          key: "",
        },
      ]
    } else {
      this.syncedAnswerOptions.splice(index, 1)
    }
  }

  generateKey(index, name) {
    if (this.allowToGenerateKey.includes(index)) {
      this.syncedAnswerOptions[index].key = this.toSnakeCase(name)
    }
  }

  toSnakeCase(name) {
    let s = name.replace(/[^\w\s]/g, "")
    s = s.replace(/\s+/g, " ")
    s = s.toLowerCase().split(" ")
    return s.filter((value) => value.length !== 0).join("_")
  }

  trim(index) {
    this.syncedAnswerOptions[index].display_name =
      this.syncedAnswerOptions[index].display_name.trim()
  }

  pushAllowToGenerateKey(index, value) {
    if (!this.allowToGenerateKey.includes(index) && _.isEmpty(value)) {
      this.allowToGenerateKey.push(index)
    }
  }

  removeAllowToGenerateKey(index) {
    _.remove(this.allowToGenerateKey, (item) => {
      return item === index
    })
  }

  @Watch("selectedTemplate")
  watchSelectedTemplate(newVal) {
    if (newVal !== "none") {
      if (newVal === "body_parts") {
        this.syncedAnswerOptions = this.syncedAnswerOptions.filter((item) =>
          this.bodyParts.find((bp) => bp.key === item.key)
        )
      } else {
        this.syncedAnswerOptions = Object.keys(this.templates[newVal]).map(
          (key) => {
            return {
              display_name: this.templates[newVal][key],
              key,
            }
          }
        )
      }
    }
  }

  @Watch("isSelectedAll")
  watchSelectedAll(newVal) {
    if (newVal) {
      this.syncedAnswerOptions = this.bodyParts
    } else {
      this.syncedAnswerOptions = []
    }
  }

  handleShowOtherOptionsChanged(value, item) {
    if (!value) {
      item.show_other_options_in_report = false
    }
  }
}
